// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file admin.proto (package org.callistovault.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_empty, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_options } from "./options_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file admin.proto.
 */
export const file_admin: GenFile = /*@__PURE__*/
  fileDesc("CgthZG1pbi5wcm90bxIUb3JnLmNhbGxpc3RvdmF1bHQudjIiIgogR2V0QnJvYWRjYXN0RW1haWxUZW1wbGF0ZVJlcXVlc3QiNAohR2V0QnJvYWRjYXN0RW1haWxUZW1wbGF0ZVJlc3BvbnNlEg8KB2N1cnJlbnQYASABKAkiSgoORW5jcnlwdGVkRW1haWwSEAoIa2V5X3R5cGUYASABKAkSEwoLa2V5X3ZlcnNpb24YAiABKAUSEQoJZW5jcnlwdGVkGAMgASgMIkkKHEdldEJyb2FkY2FzdEFkZHJlc3Nlc1JlcXVlc3QSEwoLaXNfZmVlZGJhY2sYASABKAgSFAoMbWF0Y2hlZF9vbmx5GAIgASgIIlgKHUdldEJyb2FkY2FzdEFkZHJlc3Nlc1Jlc3BvbnNlEjcKCWFkZHJlc3NlcxgBIAMoCzIkLm9yZy5jYWxsaXN0b3ZhdWx0LnYyLkVuY3J5cHRlZEVtYWlsImUKGVNlbmRCcm9hZGNhc3RFbWFpbFJlcXVlc3QSDAoEa2luZBgBIAEoCRIYChB1bndyYXBwZWRfZW1haWxzGAIgAygMEg8KB3N1YmplY3QYAyABKAkSDwoHY29udGVudBgEIAEoCSIcChpTZW5kQnJvYWRjYXN0RW1haWxSZXNwb25zZTKnAwoMQWRtaW5TZXJ2aWNlEpIBChlHZXRCcm9hZGNhc3RFbWFpbFRlbXBsYXRlEjYub3JnLmNhbGxpc3RvdmF1bHQudjIuR2V0QnJvYWRjYXN0RW1haWxUZW1wbGF0ZVJlcXVlc3QaNy5vcmcuY2FsbGlzdG92YXVsdC52Mi5HZXRCcm9hZGNhc3RFbWFpbFRlbXBsYXRlUmVzcG9uc2UiBJC1GAEShgEKFUdldEJyb2FkY2FzdEFkZHJlc3NlcxIyLm9yZy5jYWxsaXN0b3ZhdWx0LnYyLkdldEJyb2FkY2FzdEFkZHJlc3Nlc1JlcXVlc3QaMy5vcmcuY2FsbGlzdG92YXVsdC52Mi5HZXRCcm9hZGNhc3RBZGRyZXNzZXNSZXNwb25zZSIEkLUYARJ5ChJTZW5kQnJvYWRjYXN0RW1haWwSLy5vcmcuY2FsbGlzdG92YXVsdC52Mi5TZW5kQnJvYWRjYXN0RW1haWxSZXF1ZXN0GjAub3JnLmNhbGxpc3RvdmF1bHQudjIuU2VuZEJyb2FkY2FzdEVtYWlsUmVzcG9uc2UiAEIZWhdjYWxsaXN0b3ZhdWx0Lm9yZy9wcm90b2IGcHJvdG8z", [file_google_protobuf_empty, file_google_protobuf_timestamp, file_options]);

/**
 * @generated from message org.callistovault.v2.GetBroadcastEmailTemplateRequest
 */
export type GetBroadcastEmailTemplateRequest = Message<"org.callistovault.v2.GetBroadcastEmailTemplateRequest"> & {
};

/**
 * Describes the message org.callistovault.v2.GetBroadcastEmailTemplateRequest.
 * Use `create(GetBroadcastEmailTemplateRequestSchema)` to create a new message.
 */
export const GetBroadcastEmailTemplateRequestSchema: GenMessage<GetBroadcastEmailTemplateRequest> = /*@__PURE__*/
  messageDesc(file_admin, 0);

/**
 * @generated from message org.callistovault.v2.GetBroadcastEmailTemplateResponse
 */
export type GetBroadcastEmailTemplateResponse = Message<"org.callistovault.v2.GetBroadcastEmailTemplateResponse"> & {
  /**
   * @generated from field: string current = 1;
   */
  current: string;
};

/**
 * Describes the message org.callistovault.v2.GetBroadcastEmailTemplateResponse.
 * Use `create(GetBroadcastEmailTemplateResponseSchema)` to create a new message.
 */
export const GetBroadcastEmailTemplateResponseSchema: GenMessage<GetBroadcastEmailTemplateResponse> = /*@__PURE__*/
  messageDesc(file_admin, 1);

/**
 * @generated from message org.callistovault.v2.EncryptedEmail
 */
export type EncryptedEmail = Message<"org.callistovault.v2.EncryptedEmail"> & {
  /**
   * @generated from field: string key_type = 1;
   */
  keyType: string;

  /**
   * @generated from field: int32 key_version = 2;
   */
  keyVersion: number;

  /**
   * @generated from field: bytes encrypted = 3;
   */
  encrypted: Uint8Array;
};

/**
 * Describes the message org.callistovault.v2.EncryptedEmail.
 * Use `create(EncryptedEmailSchema)` to create a new message.
 */
export const EncryptedEmailSchema: GenMessage<EncryptedEmail> = /*@__PURE__*/
  messageDesc(file_admin, 2);

/**
 * @generated from message org.callistovault.v2.GetBroadcastAddressesRequest
 */
export type GetBroadcastAddressesRequest = Message<"org.callistovault.v2.GetBroadcastAddressesRequest"> & {
  /**
   * @generated from field: bool is_feedback = 1;
   */
  isFeedback: boolean;

  /**
   * @generated from field: bool matched_only = 2;
   */
  matchedOnly: boolean;
};

/**
 * Describes the message org.callistovault.v2.GetBroadcastAddressesRequest.
 * Use `create(GetBroadcastAddressesRequestSchema)` to create a new message.
 */
export const GetBroadcastAddressesRequestSchema: GenMessage<GetBroadcastAddressesRequest> = /*@__PURE__*/
  messageDesc(file_admin, 3);

/**
 * @generated from message org.callistovault.v2.GetBroadcastAddressesResponse
 */
export type GetBroadcastAddressesResponse = Message<"org.callistovault.v2.GetBroadcastAddressesResponse"> & {
  /**
   * @generated from field: repeated org.callistovault.v2.EncryptedEmail addresses = 1;
   */
  addresses: EncryptedEmail[];
};

/**
 * Describes the message org.callistovault.v2.GetBroadcastAddressesResponse.
 * Use `create(GetBroadcastAddressesResponseSchema)` to create a new message.
 */
export const GetBroadcastAddressesResponseSchema: GenMessage<GetBroadcastAddressesResponse> = /*@__PURE__*/
  messageDesc(file_admin, 4);

/**
 * @generated from message org.callistovault.v2.SendBroadcastEmailRequest
 */
export type SendBroadcastEmailRequest = Message<"org.callistovault.v2.SendBroadcastEmailRequest"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: repeated bytes unwrapped_emails = 2;
   */
  unwrappedEmails: Uint8Array[];

  /**
   * @generated from field: string subject = 3;
   */
  subject: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;
};

/**
 * Describes the message org.callistovault.v2.SendBroadcastEmailRequest.
 * Use `create(SendBroadcastEmailRequestSchema)` to create a new message.
 */
export const SendBroadcastEmailRequestSchema: GenMessage<SendBroadcastEmailRequest> = /*@__PURE__*/
  messageDesc(file_admin, 5);

/**
 * @generated from message org.callistovault.v2.SendBroadcastEmailResponse
 */
export type SendBroadcastEmailResponse = Message<"org.callistovault.v2.SendBroadcastEmailResponse"> & {
};

/**
 * Describes the message org.callistovault.v2.SendBroadcastEmailResponse.
 * Use `create(SendBroadcastEmailResponseSchema)` to create a new message.
 */
export const SendBroadcastEmailResponseSchema: GenMessage<SendBroadcastEmailResponse> = /*@__PURE__*/
  messageDesc(file_admin, 6);

/**
 * AdminService implements handlers for Callisto staff administrative actions.
 *
 * Broadcast Emails ////////////////////////////////////////////////////////
 *
 * @generated from service org.callistovault.v2.AdminService
 */
export const AdminService: GenService<{
  /**
   * @generated from rpc org.callistovault.v2.AdminService.GetBroadcastEmailTemplate
   */
  getBroadcastEmailTemplate: {
    methodKind: "unary";
    input: typeof GetBroadcastEmailTemplateRequestSchema;
    output: typeof GetBroadcastEmailTemplateResponseSchema;
  },
  /**
   * @generated from rpc org.callistovault.v2.AdminService.GetBroadcastAddresses
   */
  getBroadcastAddresses: {
    methodKind: "unary";
    input: typeof GetBroadcastAddressesRequestSchema;
    output: typeof GetBroadcastAddressesResponseSchema;
  },
  /**
   * @generated from rpc org.callistovault.v2.AdminService.SendBroadcastEmail
   */
  sendBroadcastEmail: {
    methodKind: "unary";
    input: typeof SendBroadcastEmailRequestSchema;
    output: typeof SendBroadcastEmailResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_admin, 0);

